import { Target, Sparkles } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  DraftWithAIProvider,
  DraftTrigger,
  DraftPanel,
  DraftFieldShade,
} from "@/components/admin/profile-editor/DraftWithAI";

interface Step3Props {
  data: {
    missionStatement: string;
    whatMakesUsDifferent: string;
  };
  orgId?: string | null;
  onUpdate: (data: any) => void;
}

// Maps to the public profile's MissionStatement + BrandStory ("What Makes Us
// Different") — the same profile_data keys the AboutStorySection editor writes.
const OrgOnboardingStep3 = ({ data, orgId, onUpdate }: Step3Props) => {
  return (
    <div className="space-y-6">
      <div className="space-y-5">
        <DraftWithAIProvider
          fieldKey="missionStatement"
          orgId={orgId}
          value={data.missionStatement}
          onUseDraft={(text) => onUpdate({ ...data, missionStatement: text })}
          maxLength={300}
        >
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-3">
              <Label className="flex items-center gap-2">
                <Target className="h-4 w-4 text-primary" />
                Mission statement
              </Label>
              <DraftTrigger />
            </div>
            <DraftFieldShade>
              <Textarea
                value={data.missionStatement}
                maxLength={300}
                onChange={(e) => onUpdate({ ...data, missionStatement: e.target.value.slice(0, 300) })}
                placeholder="What drives your organization? This appears as a featured pullquote on your story."
                className="min-h-[88px]"
              />
            </DraftFieldShade>
            <DraftPanel />
            <p className="text-[11px] text-muted-foreground/60 text-right">{data.missionStatement.length}/300</p>
          </div>
        </DraftWithAIProvider>

        <DraftWithAIProvider
          fieldKey="whatMakesUsDifferent"
          orgId={orgId}
          value={data.whatMakesUsDifferent}
          onUseDraft={(text) => onUpdate({ ...data, whatMakesUsDifferent: text })}
          maxLength={1000}
        >
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-3">
              <Label className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-primary" />
                Reasons an agent should join
              </Label>
              <DraftTrigger />
            </div>
            <DraftFieldShade>
              <Textarea
                value={data.whatMakesUsDifferent}
                maxLength={1000}
                onChange={(e) => onUpdate({ ...data, whatMakesUsDifferent: e.target.value.slice(0, 1000) })}
                placeholder="Share the two or three things that make you different — why an agent should choose you over competitors."
                className="min-h-[168px]"
              />
            </DraftFieldShade>
            <DraftPanel />
            <p className="text-[11px] text-muted-foreground/60 text-right">{data.whatMakesUsDifferent.length}/1000</p>
          </div>
        </DraftWithAIProvider>
      </div>
    </div>
  );
};

export default OrgOnboardingStep3;
